module.exports = __webpack_public_path__ + "media/images/riders/JACK_MOIR-cc3ad568df5514eff16e010d606388a6.png";